export const LOGINTIME_KEY = 'loginTime'
// 值为1已有debounce定时器，不调用接口，2没有debounce定时器，调用展期接口
export const HAS_EXTEND_PROCESS_KEY = 'hasExtendProcess'
export const HAS_EXTEND_PROCESS_VALUE = '1'
export const HAS_NO_EXTEND_PROCESS_VALUE = '2'
export const RND_KEY = 'rndKey'
export const SESSION = 'session'
export const UIN = 'uin'
export const SUB = 'sub'
